export function IconCheckmark() {
  return (
    <svg
      width="12"
      height="9"
      viewBox="0 0 12 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.8536 0.646447C12.0488 0.841709 12.0488 1.15829 11.8536 1.35355L4.85355 8.35355C4.75979 8.44732 4.63261 8.5 4.5 8.5C4.36739 8.5 4.24021 8.44732 4.14645 8.35355L0.646447 4.85355C0.451184 4.65829 0.451184 4.34171 0.646447 4.14645C0.841709 3.95118 1.15829 3.95118 1.35355 4.14645L4.5 7.29289L11.1464 0.646447C11.3417 0.451184 11.6583 0.451184 11.8536 0.646447Z"
        fill="currentColor"
      />
    </svg>
  );
}
